import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-tooltip-info',
  templateUrl: './tooltip-info.component.html',
  styleUrls: ['./tooltip-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TooltipInfoComponent implements OnInit {


  @Input() texto: string;

  constructor() { }

  ngOnInit() {
  }

}
